import './Icon_Check.css';

function Icon_Check() {
  return (
    <div className='icon-container-check'>
      <svg viewBox="0 0 24 24" className="check-svg">
        <path d="M20 6 9 17l-5-5" />
      </svg>
    </div>
  );
}

export default Icon_Check;